<template>
  <div class="container-cental">
    <h1 class="mt-5 mb-5">
      {{ $t("messages.listoOfArticles").toUpperCase() }}
    </h1>
    <div class="container-actions-top-table">
      <div class="container-searcher">
        <b-input-group size="sm" class="mb-2">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            placeholder="Buscador"
            v-model.trim="textSearch"
          ></b-form-input>
        </b-input-group>
      </div>
      <div class="container-add-new">
        <b-button
          variant="primary"
          @click="$router.push({ name: 'CreateArticuloProcessAdmin' })"
          >Nuevo</b-button
        >
      </div>
    </div>
    <div class="container-table">
      <b-table
        striped
        :stacked="windowWidth < 600"
        hover
        :items="itemsFiltered"
        :fields="fields"
        :busy="loadingData"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        sort-icon-left
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="textSearch.toLowerCase()"
      >
        <template #cell(idioma)="data">
          <span>{{ $t(`messages.${data.item.idioma}`) }}</span>
        </template>
        <template #cell(enviado)="data">
          <span v-if="data.item.enviado === 0">No</span>
          <span v-else>Si</span>
        </template>
        <template #cell(publicado)="data">
          <span v-if="data.item.publicado === 0">No</span>
          <span v-else>Si</span>
        </template>
        <template #cell(actions)="data">
          <b-icon
            icon="pencil-square"
            variant="warning"
            @click="editRegister({ ...data.item })"
            scale="1.5"
            style="margin: 0px 10px; cursor: pointer"
            v-b-tooltip.hover
            title="Editar"
          ></b-icon>
          <!-- publish article icon -->
          <b-icon
            icon="check-circle"
            variant="success"
            @click="publishItem({ ...data.item })"
            scale="1.5"
            style="margin: 0px 10px; cursor: pointer"
            v-b-tooltip.hover
            title="Publicar"
            v-if="data.item.publicado === 0"
          ></b-icon>
          <!-- unpublish or hide article icon -->
          <b-icon
            v-else
            icon="x-circle"
            variant="danger"
            @click="hideArticulo({ ...data.item })"
            scale="1.5"
            style="margin: 0px 10px; cursor: pointer"
            v-b-tooltip.hover
            title="Ocultar"
          ></b-icon>
          <!-- delete article icon -->
          <b-icon
            icon="trash"
            variant="danger"
            @click="deleteItem({ ...data.item })"
            scale="1.5"
            style="margin: 0px 10px; cursor: pointer"
            v-b-tooltip.hover
            title="Eliminar"
          ></b-icon>
          <!-- enviar articulo por correo -->
          <b-icon
            icon="cursor"
            variant="success"
            @click="enviarItem({ ...data.item })"
            scale="1.5"
            style="margin: 0px 10px; cursor: pointer"
            v-b-tooltip.hover
            title="Enviar por correo"
          ></b-icon>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong style="margin-left: 5px">Cargando Datos...</strong>
          </div>
        </template>
      </b-table>
    </div>
    <div class="container-paginator">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
      <span style="margin-left: 15px">Items por página</span>
      <b-form-select
        v-model="perPage"
        :options="optionsPerPage"
        style="width: 80px; margin-left: 10px"
      ></b-form-select>
    </div>
  </div>
</template>

<script>
import ArticulosService from "@/services/articulos.service";
import NewsletterService from "@/services/newsletter.service";
import EventBus from "@/services/eventBus.js";
import { Helpers } from "@/mixins/Helpers";
export default {
  name: "ArticulosList",
  mixins: [Helpers],
  data() {
    return {
      articulosService: null,
      newsletterService: null,
      sortBy: "titulo",
      fields: [
        { key: "id", sortable: true, label: "ID" },
        { key: "titulo", sortable: true, label: "Titulo" },
        { key: "autor", sortable: true, label: "Autor" },
        { key: "enviado", sortable: true, label: "Enviado a sucriptores" },
        { key: "idioma", sortable: true, label: "Idioma" },
        { key: "importancia", sortable: true, label: "Importancia" },
        { key: "publicado", sortable: true, label: "Publicado" },
        { key: "actions", sortable: false, label: "Acciones" },
      ],
      from: "articuloslistadmin",
      items: [],
      itemsFiltered: [],
      windowWidth: window.innerWidth,
      loadingData: false,
      perPage: 10,
      currentPage: 1,
      optionsPerPage: [5, 10, 25, 50, 100],
      textSearch: "",
      itemSeleted: null,
      sortDesc: false,
    };
  },
  created() {
    this.articulosService = new ArticulosService();
    this.newsletterService = new NewsletterService();
  },
  mounted() {
    this.getItemsForList();
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
    EventBus.$on("RESPONSE_MODAL_QUESTION", (payLoad) => {
      if (payLoad.from == this.from) {
        switch (payLoad.action) {
          case "publishArticle":
            this.ejecutePublishItem();
            break;
          case "hideArticle":
            this.ejecuteHideArticulo();
            break;
          case "delete":
            this.ejecuteDelete();
            break;
          case "edit":
            this.goToEdit();
            break;
          case "enviar":
            this.ejecuteEnviar();
            break;
          default:
            break;
        }
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    EventBus.$off("RESPONSE_MODAL_QUESTION");
  },
  methods: {
    enviarItem(item) {
      this.itemSeleted = { ...item };
      EventBus.$emit("SHOW_MODAL_QUESTION", {
        titleModal: "Enviar Newsletter",
        messageModal:
          "¿Seguro desea enviar el articulo por correo a los suscriptores de newsletter?",
        action: "enviar",
        from: this.from,
      });
    },
    ejecuteEnviar() {
      if (!this.itemSeleted) return false;
      this.newsletterService
        .sendNewsletter(this.itemSeleted.id)
        .then((result) => {
          if (result.data.status == 200) {
            this.items = this.items.map((item) => {
              if (item.id == this.itemSeleted.id) {
                item.enviado = 1;
              }
              return item;
            });
            this.itemsFiltered = this.itemsFiltered.map((item) => {
              if (item.id == this.itemSeleted.id) {
                item.enviado = 1;
              }
              return item;
            });
            this.itemSeleted = null;
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Felicidades",
              variant: "success",
              message: "Artículo enviado satisfactoriamente",
            });
          }
        })
        .catch(() => {
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al enviar el artículo",
          });
        });
    },
    deleteItem(item) {
      this.itemSeleted = { ...item };
      EventBus.$emit("SHOW_MODAL_QUESTION", {
        titleModal: this.$t('messages.elimination'),
        messageModal: "¿Seguro desea eliminar el articulo?",
        action: "delete",
        from: this.from,
      });
    },
    ejecuteDelete() {
      if (!this.itemSeleted) return false;
      //sustituir el servicio
      this.articulosService
        .eliminarArticulo({ id: this.itemSeleted.id })
        .then((result) => {
          if (result.data.status == 200) {
            this.items = this.items.filter((item) => {
              return item.id != this.itemSeleted.id;
            });
            this.itemsFiltered = this.itemsFiltered.filter((item) => {
              return item.id != this.itemSeleted.id;
            });
            this.itemSeleted = null;
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Felicidades",
              variant: "success",
              message: "Registro eliminado satisfactoriamente",
            });
          }
        })
        .catch(() => {
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al eliminar registro",
          });
        });
    },
    editRegister(item) {
      this.itemSeleted = { ...item };
      EventBus.$emit("SHOW_MODAL_QUESTION", {
        titleModal: "Edición",
        messageModal: "¿Seguro desea editar el registro?",
        action: "edit",
        from: this.from,
      });
    },
    goToEdit() {
      this.$router
        .push({
          name: "CreateArticuloProcessAdmin",
          params: { id: this.itemSeleted.id },
        })
        .catch(() => {});
    },
    getItemsForList() {
      this.loadingData = true;
      this.articulosService
        .allMyArticulos()
        .then((result) => {
          this.items = result.data.data.map((item) => {
            return {
              id: item.id,
              titulo: item.titulo,
              autor: item.autor,
              enviado: item.enviado,
              idioma: item.idioma,
              importancia: item.importancia,
              publicado: item.publicado,
            };
          });
          this.itemsFiltered = result.data.data.map((item) => {
            return {
              id: item.id,
              titulo: item.titulo,
              autor: item.autor,
              enviado: item.enviado,
              idioma: item.idioma,
              importancia: item.importancia,
              publicado: item.publicado,
            };
          });
          this.loadingData = false;
        })
        .catch(() => {
          this.loadingData = false;
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al recuperar items de la lista",
          });
        });
    },

    publishItem(item) {
      this.itemSeleted = { ...item };
      EventBus.$emit("SHOW_MODAL_QUESTION", {
        titleModal: "Publicación",
        messageModal: "¿Seguro desea publicar el artículo?",
        action: "publishArticle",
        from: this.from,
      });
    },
    ejecutePublishItem() {
      if (!this.itemSeleted) return false;
      this.articulosService
        .togglePublicarArticulo({ id: this.itemSeleted.id, publicado: 1 })
        .then((result) => {
          if (result.data.status == 200) {
            this.items = this.items.map((item) => {
              if (item.id == this.itemSeleted.id) {
                item.publicado = 1;
                item.fecha_publicacion = result.data.data.fecha_publicacion;
              }
              return item;
            });
            this.itemsFiltered = this.itemsFiltered.map((item) => {
              if (item.id == this.itemSeleted.id) {
                item.publicado = 1;
                item.fecha_publicacion = result.data.data.fecha_publicacion;
              }
              return item;
            });
            this.itemSeleted = null;
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Felicidades",
              variant: "success",
              message: "Artículo publicado satisfactoriamente",
            });
          } else {
            const mensaje = result.data.errores && result.data.errores.length > 0
              ? result.data.errores[0]
              : "Error al publicar el artículo";
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Error",
              variant: "danger",
              message: mensaje,
            });
          }
        })
        .catch(() => {
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al publicar registro",
          });
        });
    },
    hideArticulo(item) {
      this.itemSeleted = { ...item };
      EventBus.$emit("SHOW_MODAL_QUESTION", {
        titleModal: "Ocultar",
        messageModal: "¿Seguro desea ocultar el artículo?",
        action: "hideArticle",
        from: this.from,
      });
    },
    ejecuteHideArticulo() {
      if (!this.itemSeleted) return false;
      this.articulosService
        .togglePublicarArticulo({ id: this.itemSeleted.id })
        .then((result) => {
          if (result.data.status == 200) {
            this.items = this.items.map((item) => {
              if (item.id == this.itemSeleted.id) {
                item.publicado = 0;
                item.fecha_publicacion = result.data.data.fecha_publicacion;
              }
              return item;
            });
            this.itemsFiltered = this.itemsFiltered.map((item) => {
              if (item.id == this.itemSeleted.id) {
                item.publicado = 0;
                item.fecha_publicacion = result.data.data.fecha_publicacion;
              }
              return item;
            });
            this.itemSeleted = null;
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Felicidades",
              variant: "success",
              message: "Artículo publicado satisfactoriamente",
            });
          }
        })
        .catch(() => {
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al publicar registro",
          });
        });
    },
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-cental {
  width: 100%;
  min-height: 700px;
}
.container-table {
  width: 100%;
  min-height: 300px;
  padding-bottom: 20px;
}
.container-paginator {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
  width: 100%;
  padding-bottom: 20px;
}
.container-actions-top-table {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 20px 30px;
}
@media (max-width: 470px) {
  .container-paginator {
    flex-direction: column;
    align-items: center;
  }
}
</style>
